import _ from 'lodash'

import { generateSelector } from 'providers/product-fruits/utils'

import type { AbTestsCommonSchema, VariantsSchema } from '../../abTestsCommonSchema'
import type { RowData, TableData } from './types'
import type { AbTestVariantsSchema } from 'features/ab-tests/types/abTestVariantsSchema'
import type { EmptyObject, PartialDeep } from 'type-fest'

export const composeTableData = (
  schema: PartialDeep<AbTestVariantsSchema>,
  formValues: Partial<AbTestsCommonSchema['variants']>,
  workspaceValues: PartialDeep<VariantsSchema>,
  formVariants: string[],
): TableData => {
  const rows: RowData[] = []

  // FIXME: @typescript-eslint/no-explicit-any
  type CurrentValue = Record<string, any>

  const traverseSchema = (
    currentNode: CurrentValue,
    currentWorkspaceNode: CurrentValue,
    currentPath: string = '',
    verticalHeaders: string[] = [],
  ): void => {
    for (const key in currentNode) {
      const nodeValue: CurrentValue = currentNode[key]
      const nodeWorkspaceValue: CurrentValue = currentWorkspaceNode[key]
      const nestedPath: string = currentPath ? `${currentPath}.${key}` : key

      if (typeof nodeValue === 'object' && !_.isNil(nodeValue) && !('type' in nodeValue)) {
        const newHeaders: string[] = [...verticalHeaders]

        if ('label' in nodeValue) {
          newHeaders.push(nodeValue.label)
        }

        traverseSchema(nodeValue, nodeWorkspaceValue, nestedPath, newHeaders)
      } else if (nodeValue.type) {
        const tempRow: RowData = {
          basePrefix: nestedPath,
          variants: {},
          verticalHeaders: [...verticalHeaders, nodeValue.label],
        }

        for (const variant of formVariants) {
          const variantValues: CurrentValue | EmptyObject =
            formValues?.[variant as keyof Partial<AbTestsCommonSchema['variants']>] || {}
          const keys: string[] = nestedPath.split('.')
          let value: CurrentValue | EmptyObject = variantValues

          for (const k of keys) {
            value = value?.[k as keyof Partial<AbTestsCommonSchema['variants']>]
          }

          if (!_.isNil(tempRow.variants)) {
            tempRow.variants[variant] = {
              prefix: `${variant}.${nestedPath}`,
              type: nodeValue.type,
              value,
              workspaceValue: nodeWorkspaceValue,
            }
          }

          if (nodeValue.options) {
            tempRow.variants[variant].options = nodeValue.options
          }
        }

        rows.push(tempRow)
      }
    }
  }

  traverseSchema(schema, workspaceValues)

  return {
    horizontalHeaders: formVariants,
    rows,
  }
}

export const productFruitsSelector = (basePrefix: string): string | undefined => {
  switch (basePrefix) {
    case 'reportedKeyValue':
      return generateSelector({ step: 4, subTour: 2, tour: 5 })
    case 'trafficShare':
      return generateSelector({ step: 7, subTour: 2, tour: 5 })
    default:
      return undefined
  }
}
